export default "__VITE_ASSET__NaH1RoQV__"